module.exports = __webpack_public_path__ + "media/Waves.1069d843.mp3";